<template>
  <div class="left side-menu">
    <div class="slimscroll-menu" id="remove-scroll">
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu" id="side-menu">
          <li class="menu-title">Menu</li>
          <li>
            <router-link to="/dashboard" class="waves-effect">
              <i class="icon-accelerator"></i
              ><span class="badge badge-success badge-pill float-right"></span>
              <span> Dashboard </span>
            </router-link>
          </li>
          <li v-if="activitiesModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-cogs"></i>
              <span>
                Configurações
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span>
              </span>
            </a>

            <ul class="submenu">
              <li>
                <router-link to="/activities"
                  >Inicio de Actividades</router-link
                >
              </li>
              <li>
                <router-link to="/activities/configure_dates"
                  >Data das Notas Normais
                </router-link>
              </li>

              <li>
                <router-link to="/activities/configure_dates_exames"
                  >Data das Notas do Exame
                </router-link>
              </li>
              <!-- v-if="percentArea == true" -->
              <!-- <li v-if="percentArea == true">
                <router-link to="/percents">Percentagens</router-link>
              </li> -->
              <li v-if="users == true">
                <router-link to="/users"> Usuários</router-link>
              </li>
              <li v-if="companyProfileModule == true">
                <router-link to="/company_profile">
                  Perfil da Empresa</router-link
                >
              </li>
            </ul>
          </li>

          <li>
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fa fa-list-alt"></i>
              <span>
                Cadastros
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span>
              </span>
            </a>

            <ul class="submenu">
              <li v-if="deparmentModule == true">
                <router-link to="/departments"
                  ><span class="fas fa-building" style="font-size: 10px"></span>
                  Departamentos</router-link
                >
              </li>

              <!-- <li v-if="employeesModule == true">
                <router-link to="/employees"
                  ><span class="fas fa-users" style="font-size: 10px"></span>
                  Utilizadores</router-link
                >
              </li> -->

              <li v-if="courseModule == true">
                <router-link to="/courses"
                  ><span
                    class="fas fa-graduation-cap"
                    style="font-size: 10px"
                  ></span>
                  Cursos</router-link
                >
              </li>
              <li v-if="subjectModule == true">
                <router-link to="/subject"
                  ><span class="fas fa-book" style="font-size: 10px"></span>
                  Disciplinas</router-link
                >
              </li>
              <li v-if="classmateModule == true">
                <router-link to="/classmates"
                  ><span
                    class="mdi mdi-chair-school"
                    style="font-size: 10px"
                  ></span>
                  Turmas</router-link
                >
              </li>

              <!-- <li>
                <a href="javascript:void(0);" class="waves-effect"
                  ><i class="fa fa fa-clipboard" style="font-size: 10px"></i>
                  <span>
                    Auxiliares
                    <span class="float-right menu-arrow"
                      ><i class="mdi mdi-chevron-right"></i
                    ></span>
                  </span>
                </a>
                <ul class="submenu">
                  <li v-if="precedenceModule == true">
                    <router-link to="/subject/precedences"
                      ><span class="fa fa-share" style="font-size: 10px"></span>
                      Precedencias</router-link
                    >
                  </li>
                </ul>
              </li> -->
            </ul>
          </li>

          <li v-if="teacherModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-chalkboard-teacher"></i>
              <span>
                Professores
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span>
              </span>
            </a>
            <ul class="submenu">
              <li><router-link to="/teachers">Gerenciar</router-link></li>
              <li>
                <router-link to="/alocate_teacher_geral"
                  >Alocar Disciplinas/Turmas</router-link
                >
              </li>
            </ul>
          </li>
          <li v-if="studentModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-users"></i
              ><span>
                Estudantes
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <!-- <li><router-link to="/all-students">Gerenciar</router-link></li> -->
              <li>
                <router-link to="/enroll">Alocar estudantes</router-link>
              </li>
            </ul>
          </li>
          <!-- v-if="guidelineArea == true" -->
          <li v-if="guidelineArea == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-list"></i
              ><span>
                Pautas
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <li>
                <router-link to="/guidelines">Por Disciplina</router-link>
              </li>

              <li>
                <router-link to="/guidelinesByClassmate">Por Turma</router-link>
              </li>
            </ul>
          </li>
          <!-- <li v-if="inscriptionModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="icon-spread"></i
              ><span>
                Inscrições
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <li>
                <router-link to="/all-inscriprions">Gerenciar</router-link>
              </li>
            </ul>
          </li> -->
          <!-- <li>
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-coins"></i
              ><span>
                Pagamentos
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <li v-if="paymentModule == true">
                <router-link to="/payments">Pagamentos</router-link>
              </li>

              <li v-if="debtModule == true">
                <router-link to="/payments/debt">Dividas</router-link>
              </li>

              <li v-if="otherServiceModule == true">
                <router-link to="/extract">Outros Servicos</router-link>
              </li>

              <li v-if="manageReferenceModule == true">
                <a href="javascript:void(0);" class="waves-effect">
                  <span>
                    Ger. Referencias
                    <span class="float-right menu-arrow"
                      ><i class="mdi mdi-chevron-right"></i
                    ></span> </span
                ></a>
                <ul class="submenu">
                  <li>
                    <router-link to="/services/references"
                      >Gerenciar</router-link
                    >
                  </li>
                </ul>
              </li>
              <li v-if="confirmPaymentModule == true">
                <router-link to="/confirm_payment" class="waves-effect">
                  <span> Confirmar Pag. </span></router-link
                >
              </li>
            </ul>
          </li> -->
          <!-- <li v-if="finesModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fa fa-gavel"></i
              ><span>
                Multas
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <li><a href="#">Adicionar</a></li>
              <li><a href="#">Listar</a></li>
            </ul>
          </li> -->
          <!-- <li v-if="serviceModule == true">
            <a href="javascript:void(0);" class="waves-effect"
              ><i class="fas fa-hand-holding"></i
              ><span>
                Serviços
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span> </span
            ></a>
            <ul class="submenu">
              <li>
                <router-link to="/services">Gerenciar Serviços</router-link>
              </li>
            </ul>
          </li> -->

          <!-- <li>
            <a to="/settings" class="waves-effect"
              ><i class="fas fa-cogs"></i>
              <span>
                Definições
                <span class="float-right menu-arrow"
                  ><i class="mdi mdi-chevron-right"></i
                ></span>
              </span>
            </a>

            <ul class="submenu">
              <li v-if="users == true">
                <router-link to="/users"
                  ><span class="fas fa-user"></span> Usuários</router-link
                >
              </li>
            </ul>
          </li> -->
        </ul>
      </div>
      <!-- Sidebar -->
      <div class="clearfix"></div>
    </div>
    <!-- Sidebar -left -->
  </div>
</template>
 

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const dashboardArea = store.state.auth.role_permission.dashboard?.read || false;
const percentArea = store.state.auth.role_permission.percents?.read || false;
const guidelineArea = store.state.auth.role_permission.guideline?.read || false;
const guidelineAreaSubject =
  store.state.auth.role_permission.guideline?.bySubject || false;
const guidelineAreaClassmate =
  store.state.auth.role_permission.guideline?.byClassmate || false;
const deparmentModule =
  store.state.auth.role_permission.registers.departments?.read || false;
const employeesModule =
  store.state.auth.role_permission.registers.employees?.read || false;
const classmateModule =
  store.state.auth.role_permission.registers.classmates?.read || false;
const courseModule =
  store.state.auth.role_permission.registers.courses?.read || false;
const subjectModule =
  store.state.auth.role_permission.registers.subjects?.read || false;
const precedenceModule =
  store.state.auth.role_permission.registers.precedences?.read || false;
const activitiesModule =
  store.state.auth.role_permission.activities?.read || false;
const teacherModule = store.state.auth.role_permission.teacher?.read || false;
const studentModule = store.state.auth.role_permission.student?.read || false;
const inscriptionModule =
  store.state.auth.role_permission.inscriptions?.read || false;
const debtModule =
  store.state.auth.role_permission.payments.debt?.read || false;
const extractModule =
  store.state.auth.role_permission.payments.extracts?.read || false;
const otherServiceModule =
  store.state.auth.role_permission.payments.otherServices?.read || false;
const paymentModule =
  store.state.auth.role_permission.payments.payments?.read || false;
const renewInscriptionModule =
  store.state.auth.role_permission.payments.renew_inscritpion?.read || false;
const finesModule = store.state.auth.role_permission.fines?.read || false;
const serviceModule = store.state.auth.role_permission.services?.read || false;
const manageReferenceModule =
  store.state.auth.role_permission.activities?.read || false;
const confirmPaymentModule =
  store.state.auth.role_permission.activities?.read || false;
const supportModule = store.state.auth.role_permission.support?.read || false;
const companyLogoModule =
  store.state.auth.role_permission.definitions.company_logo?.read || false;
const companyProfileModule =
  store.state.auth.role_permission.definitions.company_profile?.read || false;
const emailModelModule =
  store.state.auth.role_permission.definitions.emailModel?.read || false;
const monthly_fees =
  store.state.auth.role_permission.definitions.monthly_fees?.read || false;
const users = store.state.auth.role_permission.definitions.users?.read || false;

// store.state.auth.authenticated

onMounted(() => {
  console.log(store.state.auth.role_permission);
});
</script>